import {Component, Input} from '@angular/core';
import {Job} from "../shared/job.model";

@Component({
  selector: 'app-job-activity',
  templateUrl: 'job-activity.component.html'
})
export class JobActivityComponent {
  @Input() job: Job;

  constructor() {
  }

  filterChanges(changes) {
    // Filter out changes where changed fields are not visible
    return changes.filter((val) => val.status || val.changed_fields.length > 0);
  }
}



// WEBPACK FOOTER //
// ./src/pages/job/job-activity/job-activity.component.ts